import request from '../../../api/request';
import {
  StudentsRemovalRequestsPendingDetailsResponse,
  StudentsRemovalRequestsPendingFiltersResponse,
  StudentsRemovalRequestsPendingResponse,
} from './types';
import {
  StudentsRemovalRequestsResolvedFiltersResponse,
  StudentsRemovalRequestsResolvedResponse,
} from './types/removal-requests-resolved';

const STUDENTS_REMOVAL_REQUEST_MANAGE = {
  REQUESTS_PENDINGS_FORM: `maintainers-portal/student-management/students-removal-request-manage/requests-pendings/form`,
  REQUESTS_RESOLVED_FORM: `maintainers-portal/student-management/students-removal-request-manage/requests-resolved/form`,
  REQUESTS_PENDINGS: `maintainers-portal/student-management/students-removal-request-manage/requests-pendings`,
  REQUESTS_PENDING_DETAILS: (studyPlanEnrollmentId: number) =>
    `maintainers-portal/student-management/students-removal-request-manage/requests-pendings/${studyPlanEnrollmentId}`,
  RESOLVE_PENDING_STUDENT_REMOVAL_REQUEST: `maintainers-portal/student-management/students-removal-request-manage/requests-pendings/resolve`,
  REQUESTS_RESOLVED: `maintainers-portal/student-management/students-removal-request-manage/requests-resolved`,
  RESOLVE_AND_CHANGE_STATE_PENDING_REQUEST: `maintainers-portal/student-management/students-removal-request-manage/requests-pendings/resolve-and-change-state`,
};

export async function getRequestsPendingsForm() {
  return request<StudentsRemovalRequestsPendingFiltersResponse>(
    STUDENTS_REMOVAL_REQUEST_MANAGE.REQUESTS_PENDINGS_FORM,
    {
      method: 'GET',
    },
  );
}
export async function getRequestsPendings(params: {
  page: number;
  studentNameOrId?: string;
  studyPlanVersionId?: number;
}) {
  return request<StudentsRemovalRequestsPendingResponse>(
    STUDENTS_REMOVAL_REQUEST_MANAGE.REQUESTS_PENDINGS,
    {
      method: 'GET',
      params,
    },
  );
}

export async function getRequestPendingDetails(studyPlanEnrollmentId: number) {
  return request<StudentsRemovalRequestsPendingDetailsResponse>(
    STUDENTS_REMOVAL_REQUEST_MANAGE.REQUESTS_PENDING_DETAILS(
      studyPlanEnrollmentId,
    ),
    {
      method: 'GET',
    },
  );
}

export async function getRequestsResolvedForm() {
  return request<StudentsRemovalRequestsResolvedFiltersResponse>(
    STUDENTS_REMOVAL_REQUEST_MANAGE.REQUESTS_RESOLVED_FORM,
    {
      method: 'GET',
    },
  );
}

export async function resolvePendingStudentRemovalRequest(data: {
  studentRemovalRequestId: number;
  status: string;
  comment?: string;
  filesIds?: number[];
}) {
  return request(
    STUDENTS_REMOVAL_REQUEST_MANAGE.RESOLVE_PENDING_STUDENT_REMOVAL_REQUEST,
    {
      method: 'POST',
      data,
    },
  );
}

export async function getRequestsResolved(params: {
  page: number;
  studentNameOrId?: string;
  studyPlanVersionId?: number;
  requestState?: string;
}) {
  return request<StudentsRemovalRequestsResolvedResponse>(
    STUDENTS_REMOVAL_REQUEST_MANAGE.REQUESTS_RESOLVED,
    {
      method: 'GET',
      params,
    },
  );
}

export async function resolveAndChangeStatePendingStudentRemovalRequest(data: {
  studentRemovalRequestId: number;
  status: string;
  comment?: string;
  filesIds?: number[];
}) {
  return request(
    STUDENTS_REMOVAL_REQUEST_MANAGE.RESOLVE_AND_CHANGE_STATE_PENDING_REQUEST,
    {
      method: 'POST',
      data,
    },
  );
}
